<nova-rich-tooltip [displayTemplate]="vaccinationTooltipTemplate" width="250">
    @for (item of data; track item; let last = $last) {
    <span>
        <strong>{{ item.vaccinationTypeName }}</strong>:
        {{ item.vaccinationStatusName }}{{ !last ? ', ' : ''}}
    </span>
    }
</nova-rich-tooltip>

<ng-template #vaccinationTooltipTemplate>
    @for (item of data; track item) {
    <div class="vaccine-item">
        <strong>{{ item.vaccinationTypeDescription }}</strong>:
        <br>
        {{ item.vaccinationStatusDescription }}
    </div>
    }
</ng-template>